
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/p/freecourses/[goalUID]/free-lessons",
      function () {
        return require("private-next-pages/content/p/freecourses/[goalUID]/free-lessons.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/p/freecourses/[goalUID]/free-lessons"])
      });
    }
  